<template>
	<div class="p-4">
		<Steps :currentStep="1"></Steps>
	</div>
	<PromotionData/>
</template>

<script>
import Steps from '../../Widgets/Promotions/NewPromotion/Steps/Steps.vue';
import PromotionData from '../../Widgets/Promotions/NewPromotion/PromotionData/PromotionData.vue';
export default {
	name: 'NewPromotionStep1',
	components: {
		Steps,
		PromotionData
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>